<template>
  <div class="container container-table">
    <div class="row vertical-10p">
      <template v-for="alert in alerts">
        <b-alert :show="alert.dismiss" dismissible :variant="alert.type" @dismissed="alert.action">
          <h4>
            <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
            <i class="icon fa fa-ban" v-else></i>
            {{`alert_${alert.type}` | translate}}!</h4>
          <p v-if="alert.type !== 'danger'">
            {{alert.message}}
          </p>
          <ul v-else>
            <li v-for="e in alert.message">
              {{e}}
            </li>
          </ul>
        </b-alert>
      </template>
        <div class="container">
          <div class="login-box box">
            <div class="login-logo">
              <router-link to="/">
                <img class="img-responsive center-block" src="/static/img/logo-lg.svg">
              </router-link>
            </div>
            <div v-if="forgotten" class="login-box-body">
              <p class="login-box-msg">
                {{'forget_password_msg' | translate}}
              </p>
                <div class="form-group has-feedback">
                  <input :disabled="disabled" type="text" class="form-control" placeholder="Username" v-model="username">
                  <span class="fa fa-at form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">
                  <input v-validate="'required|email'" data-vv-as="'email'" class="form-control" name="email" placeholder="Email" type="text" v-model="forgetEmail">
                  <span class="fa fa-envelope form-control-feedback"></span>
                  <span v-show="errors.has('email')" class="small text-danger">{{ errors.first('email') }}</span>
                </div>
                <div class="row">
                  <div class=" col-xs-12 pull-right">
                    <b-btn class="btn btn-info btn-block" :disabled="errors.any()" @click="requestPass">
                      <i class="fa fa-sign-in mr-5"></i>{{'send' | translate}}
                    </b-btn>
                  </div>
                </div>
            </div>
            <div v-else class="login-box-body">
              <p class="login-box-msg">
                {{translate('sign_in_to_start_session')}}
              </p>
              <form @submit.prevent="pepe">
                <div class="form-group has-feedback">
                  <input :disabled="disabled" type="text" class="form-control" placeholder="Username" v-model="username">
                  <span class="fa fa-at form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">
                  <input :disabled="disabled" type="password" class="form-control" placeholder="Password" v-model="password">
                  <span class="fa fa-lock form-control-feedback"></span>
                </div>
                <div class="form-group input-group">
                  <div class="input-group-addon">
                    {{translate('login_type')}}
                  </div>
                  <select :disabled="disabled" class="form-control companie-select text-center" v-model="type">
                    <option value="qualibet">Qualibet</option>
                    <option value="ipos">IPOS</option>
                  </select>
                </div>
                <div class="row">
                  <div class="col-sm-4 col-xs-12 pull-right">
                    <button :disabled="disabled" class="btn btn-success btn-block">
                      <i class="fa fa-check-circle-o mr-5"></i> {{translate('sign_in')}}
                    </button>
                  </div>
                </div>
              </form>
              <div class="text-center">
                <hr>
                <a @click="forgotten = true" class="btn btn-sm text-muted">{{'password_forgotten' | translate}}<i class="fa fa-question-circle ml-5"></i></a>
              </div>
            </div>
            <div class="overlay" v-show="loading">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      section: 'Login',
      loading: false,
      username: '',
      password: '',
      type: 'qualibet',
      response: '',
      forgetEmail: '',
      language: 'de',
      alerts: [],
      disabled: false,
      forgotten: false,
      translate (word) {
        let trans = this.$options.filters.translate(word, this.language)
        if (trans === 'undefined') {
          return false
        } else {
          return trans
        }
      }
    }
  },
  methods: {
    redirect () {
      this.forgotten = false
    },
    requestPass () {
      this.$validator.validate()
        .then(result => {
          if(result) {
            API.put('/accounting/user/password-request', {username: this.username, email: this.forgetEmail})
              .then(result => {
                let alert = {type: 'success', dismiss: 4, message: this.translate('pword_alert_msg'), action: this.redirect}
                this.alerts.push(alert)
              })
              .catch(error => {
                let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message], action: this.kek}
                this.alerts.push(alert)
              })
          }
        })
    },
    kek () {
      console.log('')
    },
    pepe () {
      let userInput = {username: this.username, password: this.password, type: this.type}
      this.loading = true
      API.post('/login', userInput)
        .then(response => {
          this.$store.commit('updateRoles', response.data.roles)
          this.$store.commit('updateToken', JSON.parse(JSON.stringify(response.data.token)))
          this.$store.commit('updateLoggedInStatus', true)
          API.get('/accounting/user')
            .then(response => {
              this.$store.commit('updateUser', response.data)
              API.get('/accounting/stores')
                .then(response => {
                  this.$store.commit('updateStores', response.data)
                  API.get('/orders/parcel-options')
                    .then(response => {
                      this.$store.commit('updateParcelOptions', response.data)
                      API.get('/accounting/company')
                        .then(company => {
                          this.$store.commit('updateParcelId', company.data.default_parcel_id)
                          this.$store.commit('updateErpSystemForCompany', company.data.erp_system_name)
                          this.loading = false
                        })
                    })
                })
              this.$router.push('home')
            })
        })
        .catch(error => {
          this.loading = false
          let message = []
          Object.keys(error.response.data).forEach(x => {
            if (x === 'message') {
              message.push(error.response.data[x])
            } else {
              message.push(error.response.data[x][0])
            }
          })
          let alert = {type: 'danger', dismiss: 4, message: message}
          this.alerts.push(alert)
        })
    }
  },
  mounted () {
    if (window.localStorage.getItem('IE')) {
      this.disabled = true
      this.alerts.push({type: 'danger', dismiss: 99, message: 'Bitte beachten Sie, dass die Anmeldung im neuen MyPlace Qualibet über den Internet Explorer nicht möglich ist. Bitte melden Sie sich hierzu über Google Chrome oder Morzilla Firefox an. Vielen Dank.'})
    }
  }
}
</script>

<style>
  .companie-select
  {
    width:80%;
    float: right;
  }
</style>
<style scoped>
  .loading-gif {
    top: 43%;
    left: 39%;
    width: 23%;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Login.vue